import { Middleware } from "../middleware"
export default {


    getTop10Rules(filter) {
        return new Middleware()
            .method('GET')
            .append('/odin/executive-dashboard/most_alert_occurrences')
            .params({
                type: filter.type,
                find: filter.find,
                startDate: filter.startDate,
                endDate: filter.endDate,
                idCompany: filter.idCompany
            })
            .build()
    },

    getGeneralInfo(filter) {
        return new Middleware()
            .method('GET')
            .append('/odin/executive-dashboard/general')
            .params({
                findBy: filter.search,
                page: filter.page,
                size: filter.size,
                startDate: filter.startDate,
                endDate: filter.endDate,
                idCompany: filter.idCompany,
                find: filter.find,

            })
            .build()
    },
    getIndicators(filter) {
        return new Middleware()
            .method('GET')
            .append('/odin/executive-dashboard/indicators')
            .params({
                find: filter.find,
                startDate: filter.startDate,
                endDate: filter.endDate,
                idCompany: filter.idCompany
            })
            .build()
    },
    getStatusIncidents (filter) {
        return new Middleware()
            .method('GET')
            .append('/odin/executive-dashboard/status/incidents')
            .params({
                find: filter.find,
                startDate: filter.startDate,
                endDate: filter.endDate,
                idCompany: filter.idCompany
            })
            .build()
    },
    getHeatMap (filter) {
        return new Middleware()
            .method('GET')
            .append('/odin/executive-dashboard/heatmap')
            .params({
                startDate: filter.startDate,
                endDate: filter.endDate,
                idCompany: filter.idCompany
            })
            .build()
    },

}